module.exports = __webpack_public_path__ + "img/collectionTracteur.649d7de6.png";